/* R44 — EasySearch YMM vehicle selector tweaks (all EasySearch widgets: homepage, pop-out garage, etc.)
   MAKE:  only BMW, Audi and Toyota. BMW first, then an "Other Makes" group.
          Toyota only appears in years that have an allowed Toyota model.
   MODEL: BMW  → grouped by series: M Models, 1 Series … 8 Series, X, Z, i (newest generation first).
          Toyota → only the GR Supra (A90) and GR Yaris.
          Audi → all models, unchanged. */
(function () {
  'use strict';

  var GROUPS = ['M Models', '1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '6 Series', '7 Series', '8 Series',
                'X Models', 'Z Models', 'i Models', 'Other Models'];
  var GEN = { U: 0, G: 1, F: 2, I: 2, E: 3 };

  var TOP_MAKE = 'BMW';
  var OTHER_MAKES = ['Audi', 'Toyota'];            // shown under "Other Makes", in this order
  var OTHER_MAKES_LABEL = 'Other Makes';
  var MODEL_FILTERS = {                            // makes listed here only show matching models
    'Toyota': /\bGR (Supra|Yaris)\b/i            // A90 GR Supra, GR Yaris
  };

  function classify(text) {
    var t = String(text || '').trim();
    var sp = t.indexOf(' ');
    var chassis = sp > 0 ? t.slice(0, sp) : '';
    var name = sp > 0 ? t.slice(sp + 1) : t;
    // chassis codes look like G20, F87, E46, U06, I12, E36/7 — otherwise treat the whole text as the name
    if (!/^[A-Z]\d{2}/.test(chassis)) { chassis = ''; name = t; }
    var m, group = 12, sub = 0;

    if ((m = name.match(/^M(\d)(?!\d)/)))            { group = 0; sub = +m[1]; }        // M2, M3 CS, M5 Touring…
    else if (/^1M\b/.test(name))                    { group = 0; sub = 1; }            // 1M Coupe
    else if ((m = name.match(/^X(\d) M(?![\d])/)))   { group = 0; sub = 10 + +m[1]; }   // X3 M, X5 M Competition
    else if (/^XM\b/.test(name))                    { group = 0; sub = 20; }           // XM
    else if (/^Z\d M(?![\d])/.test(name))          { group = 0; sub = 30; }           // Z4 M Roadster / Coupe
    else if ((m = name.match(/^(\d) Series/)))       { group = +m[1]; }                 // 3 Series Saloon
    else if ((m = name.match(/^M(\d)\d{2}/)))        { group = +m[1]; }                 // M340i, M135i → its series
    else if ((m = name.match(/^(\d)\d{2}[a-z]/i)))   { group = +m[1]; }                 // 440i, 330e
    else if ((m = name.match(/^X(\d)/)))             { group = 9;  sub = +m[1]; }       // X1…X7
    else if ((m = name.match(/^Z(\d)/)))             { group = 10; sub = +m[1]; }       // Z3, Z4
    else if (/^i/.test(name))                        { group = 11; sub = name.toLowerCase(); } // i3, i4, iX3…
    if (group > 12 || group < 0) group = 12;

    var gen = chassis ? (GEN[chassis.charAt(0)] != null ? GEN[chassis.charAt(0)] : 4) : 5;
    var num = chassis ? parseInt(chassis.slice(1), 10) || 0 : 0;
    return { group: group, sub: sub, gen: gen, num: num, chassis: chassis };
  }

  function cmp(a, b) {
    if (a.k.group !== b.k.group) return a.k.group - b.k.group;
    if (a.k.sub !== b.k.sub) return a.k.sub < b.k.sub ? -1 : 1;
    if (a.k.gen !== b.k.gen) return a.k.gen - b.k.gen;          // newest generation first
    if (a.k.num !== b.k.num) return a.k.num - b.k.num;          // G80 before G81 before G82
    return a.i - b.i;                                           // keep app order (base model before M Performance)
  }

  function role(select) {
    var first = select.options[0];
    if (!first || first.value !== '') return '';
    var t = first.text || '';
    if (/model/i.test(t)) return 'model';
    if (/make/i.test(t)) return 'make';
    if (/year/i.test(t)) return 'year';
    return '';
  }

  // Selected value of the sibling Year / Make select in the same widget
  function sibling(select, want) {
    var holder = select.closest('.easysearch-select-holder');
    var box = holder && holder.parentElement;
    if (!box) return '';
    var sels = box.querySelectorAll('select');
    for (var i = 0; i < sels.length; i++) {
      if (sels[i] !== select && role(sels[i]) === want) {
        var o = sels[i].options[sels[i].selectedIndex];
        return o && o.value ? (o.text || '').trim() : '';
      }
    }
    return '';
  }

  // Years in which a filtered make (e.g. Toyota) has at least one allowed model — read from EasySearch's own data
  var yearCache = {};
  function makeHasModels(make, year) {
    var re = MODEL_FILTERS[make];
    if (!re || !year) return true;
    var key = make + '|' + year;
    if (key in yearCache) return yearCache[key];
    var tree = window.easysearch && window.easysearch.tree;
    if (!tree) return true; // data not ready — don't hide anything
    var prefix = year + ',' + make + ',', found = false;
    for (var key0 in tree) {
      var k = key0.charAt(0) === '/' ? key0.slice(1) : key0;
      if (k.indexOf(prefix) === 0) {
        var model = k.slice(prefix.length).replace(/,$/, '');
        if (model && model.indexOf(',') === -1 && re.test(model)) { found = true; break; }
      }
    }
    return (yearCache[key] = found);
  }

  function signature(select) {
    var s = [];
    for (var i = 0; i < select.options.length; i++) s.push(select.options[i].value);
    return s.join('\u0001');
  }

  function rebuild(select, placeholder, loose, groups) {
    var current = select.value;
    var frag = document.createDocumentFragment();
    frag.appendChild(placeholder);
    loose.forEach(function (o) { frag.appendChild(o); });
    groups.forEach(function (g) {
      if (!g.items.length) return;
      var og = document.createElement('optgroup');
      og.label = g.label;
      g.items.forEach(function (o) { og.appendChild(o); });
      frag.appendChild(og);
    });
    select.textContent = '';
    select.appendChild(frag);
    select.value = current;
  }

  function processMake(select) {
    var year = sibling(select, 'year');
    var placeholder = select.options[0], top = [], others = OTHER_MAKES.map(function () { return null; }), extra = [];
    for (var i = 1; i < select.options.length; i++) {
      var o = select.options[i], name = (o.text || '').trim();
      var idx = OTHER_MAKES.indexOf(name);
      if (name === TOP_MAKE) top.push(o);
      else if (idx > -1 && makeHasModels(name, year)) others[idx] = o;
      else if (o.selected) extra.push(o);            // never drop a vehicle that's already selected (e.g. from the garage)
    }
    rebuild(select, placeholder, top, [{ label: OTHER_MAKES_LABEL, items: others.filter(Boolean).concat(extra) }]);
  }

  function processModel(select) {
    var make = sibling(select, 'make');
    var placeholder = select.options[0];
    var re = MODEL_FILTERS[make];
    if (re) {
      var keep = [];
      for (var j = 1; j < select.options.length; j++) {
        var op = select.options[j];
        if (re.test(op.text) || op.selected) keep.push(op);
      }
      rebuild(select, placeholder, keep, []);
      return;
    }
    if (make !== TOP_MAKE) return;                   // Audi etc. keep EasySearch's order

    var items = [];
    for (var i = 1; i < select.options.length; i++) {
      var o = select.options[i];
      items.push({ o: o, i: i, k: classify(o.text) });
    }
    items.sort(cmp);
    var groups = [];
    items.forEach(function (it) {
      var last = groups[groups.length - 1];
      if (!last || last.g !== it.k.group) groups.push(last = { g: it.k.group, label: GROUPS[it.k.group], items: [] });
      last.items.push(it.o);
    });
    rebuild(select, placeholder, [], groups);
  }

  function processSelect(select) {
    var r = role(select);
    if (r !== 'make' && r !== 'model') return;
    if (select.options.length < 2) return;
    var ctx = r === 'make' ? sibling(select, 'year') : sibling(select, 'make');
    var sig = ctx + '\u0002' + signature(select);
    if (select._r44sig === sig) return;              // already handled, nothing new
    if (r === 'make') processMake(select); else processModel(select);
    select._r44sig = ctx + '\u0002' + signature(select);
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('.easysearch-select-holder select');
    for (var i = 0; i < list.length; i++) processSelect(list[i]);
  }

  var pending = false;
  function queue() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(document); }, 30);
  }

  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && (t.tagName === 'SELECT' || t.tagName === 'OPTGROUP' || (t.closest && t.closest('[class*="easysearch"]')))) { queue(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'SELECT' && e.target.closest('.easysearch-select-holder')) setTimeout(queue, 50);
    }, true);
  }

  window.R44YmmSort = { classify: classify, scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
